module.exports = __webpack_public_path__ + "static/media/information-delete.e0c8a72c.svg";